// src/theme/CustomThemeProvider.tsx
import { ChakraProvider } from '@chakra-ui/react';
import React, { createContext, useContext, useState } from 'react';
import { theme } from '.'

// Tipo das chaves dos temas
type ThemeKeys = 'default';

// Contexto para manipular o tema
const ThemeContext = createContext<{
  currentTheme: ThemeKeys;
  changeTheme: (themeName: ThemeKeys) => void;
} | null>(null);

// Hook para usar o contexto do tema
export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

// Provedor do tema
export const CustomThemeProvider = ({ children }: { children: React.ReactNode }) => {
  const [currentTheme, setCurrentTheme] = useState<ThemeKeys>('default');

  const changeTheme = (themeName: ThemeKeys) => {
    setCurrentTheme(themeName);
  };

  return (
    <ThemeContext.Provider value={{ currentTheme, changeTheme }}>
      <ChakraProvider theme={theme}>{children}</ChakraProvider>
    </ThemeContext.Provider>
  );
};
